import React from "react";
import type { SolutionFeedbackFieldProps } from "../../../../../../../../types/feedback/feedback";
import CustomSelect from "../../../../../../../common/custom-select";
import CustomTextArea from "../../../../../../../common/custom-text-area";

const ImpactField: React.FC<SolutionFeedbackFieldProps> = ({ formState, setFormState }) => (
  <div>
    <label className="block text-[16px] font-medium text-brand-textSubheading mb-[24px]">
      Is this solving a real problem for you today?
    </label>
    <CustomSelect
      options={[
        { label: "Yes", value: "yes" },
        { label: "Partially", value: "partially" },
        { label: "No", value: "no" },
      ]}
      selectedValue={formState.impactResponse}
      onChange={(value) => setFormState((prev) => ({ ...prev, impactResponse: value, challengeText: "", priorityLevel: "", buyingSignal: "", whyNot: "" }))}
      placeholder="Select an option..."
    />
    {(formState.impactResponse === "yes" || formState.impactResponse === "partially") && (
      <div className="mt-[30px]">
        <label className="block text-[16px] font-medium text-brand-textSubheading mb-[22px]">
          What problem were you thinking of?
        </label>
        <CustomTextArea
          value={formState.challengeText}
          onChange={(e) => setFormState((prev) => ({ ...prev, challengeText: e.target.value }))}
          placeholder="Describe the challenge..."
          maxLength={1024}
        />
      </div>
    )}
  </div>
);

export default ImpactField;
